import { useState } from 'react'
import EditorFeatureTitle from "../../components/editor/EditorFeatureTitle"
import EditorFeatureSubtitle from '../../components/editor/EditorFeatureSubtitle'
import EditorFeatureReportItem from '../../components/editor/EditorFeatureReportItem'

const DialogueAdverbs = () => {
	const [reports] = useState([
		{
			label: 'Additionally ',
			appearence: 3
		},
		{
			label: 'Closely',
			appearence: 1
		},
		{
			label: 'Formerly',
			appearence: 5
		}
	])

	return (
		<div className='bg-white shadow-sm lg:p-9 xl:p-9 2xl:p-10'>
			<EditorFeatureTitle title='Dialogue Adverbs' />
			<EditorFeatureSubtitle>
				Lorem ipsum dolor sit amet, consectetur adipiscing elit
			</EditorFeatureSubtitle>
			<div className='lg:space-y-4  2xl:space-y-5 lg:mt-7 xl:mt-8 2xl:mt-9'>
				{reports.map((report, i) => (
					<EditorFeatureReportItem
						key={i}
						label={report.label}
						appearence={report.appearence}
					/>
				))}
			</div>
		</div>
	)
}

export default DialogueAdverbs